async function getAcf(param) {
  const url = 'https://fastsite.pl/wp-json/acf/v3/' + param;
  const response = await fetch(url);
  //  console.log(process.env.REACT_APP_WP_ADMIN_URL + "/wp-json/wp/v2/posts");
  return await response.json();
}

export default getAcf;
